import { ApiResponse } from 'apisauce';

import config from '../../config';
import { PredefinedMilisecondsTypeEnum } from '../enums';
import { FILE_REQUEST_TIMEOUT } from '../libSettings';
import { UserPreferencesRequest } from '../store/file/types';

import { CacheService } from './cache/Cache.service';
import { CacheName, HttpMethods } from './cache/types';
import { BaseRequestService } from './BaseRequest.service';
import { IFileService } from './types';

const API_PATH = {
  get: '/File',
  upload: '/File',
  deleteByName: '/File?fileName=',
  userPreferences: '/File/user-preferences',
};

const cacheService = CacheService.getService();

export class FileService extends BaseRequestService implements IFileService {
  protected getBaseUrl(): string {
    return config.file.url;
  }

  constructor() {
    super(FILE_REQUEST_TIMEOUT);
  }

  get(fileName: string): Promise<ApiResponse<string>> {
    if (!fileName) {
      throw new Error('[File.service] File name not provided');
    }

    return this.api.get<string>(`${API_PATH.get}/${fileName}`);
  }


  async uploadUserPreferenceFile(data: UserPreferencesRequest) {
    if (!data) {
      throw new Error('[File.service] No file data given');
    }

    // Evict all user-preferences caches because uploads can update any preference payload.
    cacheService.evictCache(`${CacheName.userPreferences}:${HttpMethods.GET}`);
    return this.api.post<UserPreferencesRequest>(API_PATH.userPreferences, data);
  }

  async getUserPreferenceFile(preferenceName: string) {
    const APIPath = `${API_PATH.userPreferences}/${preferenceName}`;
    const url = this.getBaseUrl() + APIPath;
    const cacheName = CacheName.userPreferences;

    this.addOrUpdateCacheDefinition(
      url,
      cacheName,
      HttpMethods.GET,
      PredefinedMilisecondsTypeEnum.oneMinute,
    );
    return this.api.get(APIPath);
  }

  deleteByName(fileName: string): Promise<ApiResponse<null>> {
    return this.api.delete<null>(API_PATH.deleteByName + fileName);
  }
}
